import React from 'react'
import Layout from '../../component/Layout';
import { t } from 'i18next';
import ProfileCreationGuide from '../../component/ProfileCreation';

const ProfileCreationContainer = () => {
	return (
		<Layout title={t("profile_creation")} description={t("profile_creation_desc")}>
			<ProfileCreationGuide />
		</Layout>
	)
}

export default ProfileCreationContainer